import {h, Fragment} from "preact"
import { useAppStateSelector, pick, useSort } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import { sortOptions } from "../config"


export default function NativeToolbar() {

    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )

    const docCount = response.products?.total ?? 0

    const { activeSort, setSort } = useSort(sortOptions)

    const handleSortChange = event => {
        console.log("HANDLE SORT CHANGE", event.target)
        setSort(event.target.value)
    }

    // Fixed: Use array destructuring instead of object destructuring
    const [isSortOpen, setIsSortOpen] = useState(false);

    // Debug logging
    useEffect(() => {
        console.log("isSortOpen state changed:", isSortOpen);
        
        const handleXButtonClick = function() {
            console.log("X BUTTON CLICKED");
            // Close the popover when X button is clicked
            setIsSortOpen(false);
        };
        
        // Try to access the popover element
        const popover = document.querySelector('facets-sort-popover');
        if (popover) {
            console.log("Popover element found:", popover);
            
            // Try to access shadow root
            if (popover.shadowRoot) {
                console.log("Shadow root accessible:", popover.shadowRoot);
                // You can now query inside the shadow root
                const internalElements = popover.shadowRoot.querySelectorAll('*');
                console.log("Elements inside shadow root:", internalElements);
                
                // Add event listener with cleanup
                const elementInShadow = popover.shadowRoot.querySelector('header button');
                if (elementInShadow) {
                    elementInShadow.addEventListener("click", handleXButtonClick);
                }
                
                // Cleanup function to remove the event listener
                return () => {
                    if (elementInShadow) {
                        elementInShadow.removeEventListener("click", handleXButtonClick);
                    }
                };
            } else {
                console.log("Shadow root not accessible (might be closed mode)");
            }
            
            // Try setting attributes or calling methods
            if (isSortOpen) {
                popover.setAttribute('open', '');
                // Or try calling methods if they exist
                if (typeof popover.show === 'function') {
                    popover.show();
                }
            } else {
                popover.removeAttribute('open');
                if (typeof popover.hide === 'function') {
                    popover.hide();
                }
            }
        }
    }, [isSortOpen]);
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    console.log("OPTIONS", options, activeSort);

    return (
        <div class="collection-toolbar full-bleed">
            <div class="collection-toolbar__button-list">
                <div class="collection-toolbar__button-container md:hidden">
                    <button onClick={(e) => {
                        document.querySelector('label[for="toggle-mobile-sidebar"]').click();
                    }} type="button" class="flex flex-row items-center w-full gap-1 text-sm collection-toolbar__button" aria-expanded="false">
                        Filter
                        <svg aria-hidden="true" focusable="false" fill="none" width="15" class="icon icon-adjust" viewBox="0 0 20 20">
                            <path
                                fill="currentColor"
                                fill-rule="evenodd"
                                d="M9.095 6.25a3.001 3.001 0 0 1 5.81 0h1.345a.75.75 0 0 1 0 1.5h-1.345a3.001 3.001 0 0 1-5.81 0h-5.345a.75.75 0 0 1 0-1.5h5.345Zm1.405.75a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
                            ></path>
                            <path
                                fill="currentColor"
                                fill-rule="evenodd"
                                d="M8 16a3.001 3.001 0 0 0 2.905-2.25h5.345a.75.75 0 0 0 0-1.5h-5.345a3.001 3.001 0 0 0-5.81 0h-1.345a.75.75 0 0 0 0 1.5h1.345a3.001 3.001 0 0 0 2.905 2.25Zm1.5-3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                            ></path>
                        </svg>
                    </button>
                </div>
                <div class="text-sm collection-toolbar__products-count md:hidden">
                    {docCount} products
                </div>
                <div class="collection-toolbar__button-container">
                    {/* Fixed: Use arrow function with functional state update and event handling */}
                    <button onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        console.log("Button clicked, current state:", isSortOpen);
                        setIsSortOpen(prevState => {
                            console.log("Updating state from", prevState, "to", !prevState);
                            return !prevState;
                        });
                    }} type="button" aria-controls="sort-by-popover" class="w-full text-sm collection-toolbar__button" aria-expanded={isSortOpen} aria-haspopup="dialog">
                        <span class="justify-center text-with-icon">
                            Sort by
                            <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-chevron-down" viewBox="0 0 10 10">
                                <path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"></path>
                            </svg>
                        </span>
                    </button>
                    {/* Updated style to be dynamic based on isSortOpen state */}
                    <facets-sort-popover 
                        section-id="template--17215969132642__main" 
                        class="popover popover--bottom-end color-scheme color-scheme--dialog" 
                        close-on-listbox-select="" 
                        role="dialog" 
                        style={`display: ${isSortOpen ? 'block' : 'none'}; opacity: ${isSortOpen ? '1' : '0'};`}
                    >
                        <p class="text-sm w-fit" slot="header">Sort by</p>

                        <x-listbox class="popover__value-list" role="listbox">
                        {options.map(option => (
                            <button type="button" class="popover-listbox__option group" aria-selected={option.value == activeSort} role="option" key={option.value} value={option.value} onClick={e => handleSortChange(e)}>
                                <span class="text-sm tracking-slight lg:text-xs lg:uppercase lg:tracking-widest" style="pointer-events: none;">{option.label}</span>
                            </button>
                        ))}
                        </x-listbox>
                    </facets-sort-popover>

                </div>
            </div>
            <p class="text-sm collection-toolbar__products-count md-max:hidden">
            {docCount} products
            </p>
            <p class="py-6 pr-8 font-sans text-sm font-normal md-max:hidden border-inline-end pl-11">Filter</p>
        </div>

    ) 
}